import { TextareaAutosize } from "@material-ui/core"
import { swalWithConfirmAndCancelButtons } from "components/custom/swal"
import download from "downloadjs"
import moment from "moment"
import React, { useEffect, useState } from "react"
import Loader from "react-loaders"
import { toast } from "react-toastify"
import { Col, Input, Label, Modal, Row } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import colors from "utils/colors"

const ActionReportModal = ({
  isOpen,
  toggleModal,
  actionItem,
  alternativeId,
}) => {
  const [isDownloading, setIsDownloading] = useState(false)

  const downloadReport = async format => {
    setIsDownloading(true)
    api
      .downloadDynamicReport(
        actionItem.route,
        actionItem.actionName,
        alternativeId,
        format
      )
      .then(
        blob => {
          setIsDownloading(false)
          debugger
          download(
            blob,
            `${actionItem.actionName}.${format == "pdf" ? "pdf" : "xls"}`
          )
        },
        err => {
          setIsDownloading(false)
        }
      )
  }

  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      size="md"
      toggle={() => {
        toggleModal()
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          {actionItem?.actionName} Report
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal()
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="mb-3 d-flex-row ai-center gap-3">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => downloadReport("xls")}
            disabled={isDownloading}
          >
            Download XLS
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => downloadReport("pdf")}
            disabled={isDownloading}
          >
            Download PDF
          </button>
        </div>
      </div>

      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={toggleModal}
        >
          Close
        </button>
      </div>
    </Modal>
  )
}

export default ActionReportModal
